import { Settings24Regular } from "@fluentui/react-icons";
import { Button, Tooltip } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import styles from "./SettingsButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
}

export const SettingsButton = ({ className, onClick }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Tooltip content={t("developerSettings")} relationship="label">
                <Button appearance="subtle" icon={<Settings24Regular />} onClick={onClick} aria-label={t("developerSettings")} />
            </Tooltip>
        </div>
    );
};
